import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { NotificacaoService } from "../../services/notificacao.service";
import { CarregandoService } from "../../services/carregando.service";
import { UtilitarioService } from "../../services/utilitario.service";
import { GlobalService } from "../../services/global.service";
import { ContatoService } from "../../services/contato.service";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { ClienteService } from "../../services/cliente.service";

@Component({
  selector: 'app-importar-transferencia-vendedores-modal',
  templateUrl: './importar-transferencia-vendedores-modal.component.html',
  styleUrls: ['./importar-transferencia-vendedores-modal.component.scss']
})
export class ImportarTransferenciaVendedoresModalComponent implements OnInit {
  selectedFile: File;
  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    public dialogRef: MatDialogRef<ImportarTransferenciaVendedoresModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private utilitarioService: UtilitarioService,
    private globalService: GlobalService,
    private clienteService: ClienteService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
  }

  importar() {
    const dados = new FormData();
    dados.append('arquivo', this.selectedFile);
    this.carregandoService.mostra('importar');
    this.clienteService.importarPlanilhaTransVendedores(dados).subscribe((resp) => {
      this.carregandoService.esconde('importar');

      if (resp.size > 0) {
        this.utilitarioService.saveBlob(resp, 'TransfVendedoresInvalidos.xlsx');
        this.notificacaoService.sucesso('Transferências Válidas Importadas com Sucesso!!!');
        this.notificacaoService.erro('Existem validações a serem feitas, confira o arquivo gerado em Downloads!!!');
      } else {
        this.notificacaoService.sucesso('Importados com sucesso!!!');
      }

      this.dialogRef.close(true);
    }, (erro) => {
      this.carregandoService.esconde('importar');
      this.notificacaoService.erro(erro);
    });
  }

  fechar() {
    this.dialogRef.close();
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
  }

  excluirArquivo() {
    this.selectedFile = undefined;
  }

}
